import React from "react"
import { css } from "@emotion/css"
import { useOnlineStatus } from "src/hooks/useOnlineStatus"

const bannerStyle = css({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 9999,
  padding: "10px 16px",
  background: "#d13212",
  color: "#ffffff",
  textAlign: "center",
  fontSize: "14px",
  fontWeight: 700,
  animation: "slideDown 200ms ease-out",
  "@keyframes slideDown": {
    from: { transform: "translateY(-100%)" },
    to: { transform: "translateY(0)" },
  },
})

/**
 * Shows a fixed banner at the top of the screen when the device loses
 * network connectivity. Auto-dismisses when connectivity returns.
 */
const OfflineBanner: React.FC = () => {
  const offline = !useOnlineStatus()

  if (!offline) return null

  return (
    <div className={bannerStyle} role="alert" aria-live="assertive">
      ⚠️ No network connection — check WiFi
    </div>
  )
}

export default OfflineBanner
